import { Avatar, createStyles, makeStyles, Theme } from "@material-ui/core"
import ExternalUrls from "../../../app/ExternalUrls";


const useStyles = makeStyles((theme: Theme) => createStyles({
    avatarRoot: {
        width: 60,
        height: 60,
    },
    avatarImg: {
        objectFit: 'cover',
    },
    avatarFallbackImg: {
        width: 60,
        height: 60,
        objectFit: 'cover'
    }
}));



type Param = {
    vmnr?: string
}

const AvatarPicture: React.FC<Param> = ({ vmnr = 'portrait_mann' }) => {
    const classes = useStyles();
    const avatarSrc = `${ExternalUrls.RHLD_PORTRAITS}/${vmnr}.jpg`;

    return (
        <>
            <Avatar alt="Ansprechpartner" classes={{ img: classes.avatarImg, root: classes.avatarRoot }} sizes=''
                src={avatarSrc}>
                <img className={classes.avatarFallbackImg} src={ExternalUrls.RHLD_PORTRAITS_DEFAULT} alt="Ansprechpartner" />
            </Avatar>

        </>);
}

export default AvatarPicture;